module.exports = __webpack_public_path__ + "static/media/Community Service.b6f7e936.pdf";